import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import {
  Championship,
  ChampionshipDetails,
  SaveChampionshipData,
} from '../../types/Event';

@Injectable()
export class ChampionshipApiService {
  private readonly championshipsUrl = `${apiConfiguration.baseApiUrl}/championships`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getChampionships(): Promise<HttpResponse<Championship[]>> {
    return lastValueFrom(this.http.get<HttpResponse<Championship[]>>(this.championshipsUrl, { headers: this.getHeaders() }));
  }

  public async getChampionship(championshipId: string): Promise<HttpResponse<ChampionshipDetails | null>> {
    return lastValueFrom(this.http.get<HttpResponse<ChampionshipDetails | null>>(`${this.championshipsUrl}/${championshipId}`, { headers: this.getHeaders() }));
  }

  public async createChampionship(data: SaveChampionshipData): Promise<HttpResponse<Championship>> {
    return lastValueFrom(this.http.post<HttpResponse<Championship>>(this.championshipsUrl, data, { headers: this.getHeaders() }));
  }

  public async updateChampionship(championshipId: string, data: Partial<SaveChampionshipData>): Promise<HttpResponse<Championship>> {
    return lastValueFrom(this.http.put<HttpResponse<Championship>>(`${this.championshipsUrl}/${championshipId}`, data, { headers: this.getHeaders() }));
  }

  public async uploadChampionshipLogo(championshipId: string, logo: File): Promise<HttpResponse<Championship>> {
    const formData = new FormData();
    formData.append('logo', logo);
    return lastValueFrom(this.http.post<HttpResponse<Championship>>(`${this.championshipsUrl}/${championshipId}/logo`, formData, { headers: this.getHeaders() }));
  }

  public async deleteChampionship(championshipId: string): Promise<HttpResponse<void>> {
    return lastValueFrom(this.http.delete<HttpResponse<void>>(`${this.championshipsUrl}/${championshipId}`, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
